import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { Subject } from 'rxjs';
import { AngularModalService } from 'src/app/core/services/modal.service';

@Component({
  selector: 'app-user-card-actions-modal',
  templateUrl: './user-card-actions-modal.component.html'
})
export class UserCardActionsModalComponent implements OnInit {

  modalData: any;
  public onClose: Subject<any>;

  constructor(
    private bsModalRef: BsModalRef,
    private angularModalService: AngularModalService,
    public bsModalService: BsModalService
  ) {
    this.onClose = new Subject();
    if (this.bsModalService.config.initialState) {
      this.modalData = this.bsModalService.config.initialState;
    }
  }

  ngOnInit() { }

  closeModal(data) {
    this.onClose.next(data);
    this.bsModalRef.hide();
  }

  deleteCallback() {
    this.closeModal({ callbackType: 'delete' });
  }

  saveCallback(data) {
    this.closeModal({ callbackType: 'save', entity: data });
  }

  cancelCallback() {
    this.closeModal(null);
  }
}
